<div class="modal-content" style="zoom: 0.85;">
    <ng-container *ngIf="resetOperador; else trocaSenhaObrigatoria">
        <div class="modal-header">
            <h6 class="modal-title" id="modal-title-default">{{'RESETAR_SENHA_BTN' | translate}}</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-2">
                    <div class="row">
                        <div class="col-12 text-center mt-4">
                            <img src="../../../../assets/img/icons/svg/icon_security_check.svg" width="80">
                        </div>
                    </div>
                </div>
                <div class="col-9">
                    <div class="row">
                        <div class="col-12">
                            <span style="font-size: 22px; font-weight: bolder;" [translate]="'RESET_SENHA_MSG_MODAL'"></span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 form-group">
                            <label [translate]="'SENHA_NOVA'"></label>
                            <div class="d-flex">
                                <input type="text" class="form-control w-90" [(ngModel)]="nova_senha_gerada" readonly>
                                <button type="button" class="mt-1 ml-2 btn btn-md btn-dark btn-icon-only rounded-circle" (click)="copyToClipboard(nova_senha_gerada)" container=".modal" [ngbTooltip]="('COPIAR' | translate)">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-center">
            <button 
                type="button" 
                class="btn btn-darkblue badge-pill" 
                style="padding-left: 60px !important; padding-right: 60px !important;"
                (click)="close()"
            >
                Ok
            </button>
        </div>
    </ng-container>
    <ng-template #trocaSenhaObrigatoria>
        <div class="modal-header">
            <h6 class="modal-title" id="modal-title-default">{{'TROCA_SENHA_OBRIGATORIA' | translate}}</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="resetPasswordForm">
                <div class="row">
                    <div class="col-2">
                        <div class="row">
                            <div class="col-12 text-center mt-4">
                                <img src="../../../../assets/img/icons/svg/icon_security_check.svg" width="80">
                            </div>
                        </div>
                    </div>
                    <div class="col-9">
                        <div class="row">
                            <div class="col-12">
                                <span style="font-size: 22px; font-weight: bolder;" [translate]="'QUESTAO_SEGURANCA_TROQUE_SENHA'"></span>
                                <span class="pl-1" style="font-size: 22px; font-weight: bolder; text-transform: uppercase; color: red;" [translate]="'OBRIGATORIA'"></span>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12 form-group">
                                <label [translate]="'SENHA_ATUAL'"></label>
                                <div class="input-group">
                                    <input type="{{passwords_type.old}}" class="form-control" formControlName="old_password" [placeholder]="('SENHA_ATUAL_PLACEHOLDER' | translate)" autocomplete="off">
                                    <div class="input-group-append" (click)="changePassView(1)">
                                        <i class="input-group-text far" style="cursor: pointer; background-color: #2dce89; color: #ffffff;"
                                          [ngClass]="{'fa-eye': passwords_type.old === 'password', 'fa-eye-slash': passwords_type.old === 'text'}"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2 form-group mb-0">
                                <label [translate]="'NOVA_SENHA'"></label>
                            </div>
                            <div class="col-1">
                                <label
                                    *ngIf="strength"
                                    [ngClass]="{'text-danger': strength < 24, 'text-warning2': strength > 24 && strength <= 75, 'text-info': strength > 75 && strength <= 90, 'text-success': strength > 90 && strength <= 100}"
                                    style="font-size: 11px; font-family: 'PoppinsBold';">
                                    {{strengthText}}
                                </label>
                            </div>
                            <div class="col-5">
                                <div *ngIf="strength" class="progress" container=".modal" ngbTooltip="{{ strengthText }}" tooltipClass="custom-bottom-tooltip"
                                    style="margin-top: 9px;">
                                    <div class="progress-bar bg-info"
                                        [ngClass]="{'bg-danger': strength < 24, 'bg-warning': strength > 24 && strength <= 75, 'bg-info': strength > 75 && strength <= 90, 'bg-success': strength > 90 && strength <= 100}"
                                        role="progressbar" aria-valuenow="cliente.limite_contrato" aria-valuemin="0" aria-valuemax="100"
                                        [ngStyle]="{'width': strength + '%'}">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="input-group">
                            <input type="{{passwords_type.new}}" class="form-control" formControlName="new_password" [placeholder]="('NOVA_SENHA_PLACEHOLDER' | translate)" (keyup)="passwordStrength()" autocomplete="off">
                            <div class="input-group-append" (click)="changePassView(2)">
                                <i class="input-group-text far" style="cursor: pointer; background-color: #2dce89; color: #ffffff;"
                                  [ngClass]="{'fa-eye': passwords_type.new === 'password', 'fa-eye-slash': passwords_type.new === 'text'}"></i>
                            </div>
                        </div>
                        <span *ngIf="resetPasswordForm.value.new_password && strength < 90" class="mt-1 font-14" style="color: rgb(255, 149, 0);" [translate]="'NECESSARIO_NOVA_SENHA'"></span>
                        <div class="row mt-4">
                            <div class="col-12">
                                <label style="font-weight: bolder; font-size: 14px;" [translate]="'CONFIRMAR_SENHA'"></label>
                                <div class="input-group">
                                    <input type="{{passwords_type.confirm}}" class="form-control" formControlName="confirm_password" [placeholder]="('CONFIRMAR_SENHA_PLACEHOLDER' | translate)" autocomplete="off">
                                    <div class="input-group-append" (click)="changePassView(3)">
                                        <i class="input-group-text far" style="cursor: pointer; background-color: #2dce89; color: #ffffff;"
                                          [ngClass]="{'fa-eye': passwords_type.confirm === 'password', 'fa-eye-slash': passwords_type.confirm === 'text'}"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span *ngIf="resetPasswordForm.value.confirm_password && (resetPasswordForm.value.new_password !== resetPasswordForm.value.confirm_password)" class="mt-1 font-14" style="color: rgb(255, 149, 0);;" [translate]="'SENHAS_NAO_COINCIDEM'"></span>
                    </div>
                </div>
            </form>
        </div>
        <div class="modal-footer">
            <button 
                type="button" 
                class="btn btn-success badge-pill" 
                style="padding-left: 40px !important; padding-right: 40px !important;"
                [disabled]="verifyDisabled()" 
                [translate]="'SALVAR'"
                (click)="submitNewPassword(resetPasswordForm.value)"
            >
            </button>
        </div>
    </ng-template>
</div>